import React, { useEffect, useState } from "react";
import { getAds, adImpression, adClick } from "@/lib/api";

export default function AdSlot({ placement = "sidebar", className = "" }) {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    getAds(placement).then((data) => {
      setAds(data || []);
      (data || []).forEach((a) => adImpression(a.id));
    }).catch(() => {});
  }, [placement]);

  if (!ads.length) return null;

  return (
    <div className={className}>
      {ads.map((ad) => (
        <a
          key={ad.id}
          data-testid={`ad-${ad.id}`}
          href={ad.link}
          target="_blank"
          rel="noreferrer"
          onClick={() => adClick(ad.id)}
          className="group block border border-border overflow-hidden hover-lift"
        >
          <div className="relative h-40 overflow-hidden">
            <img src={ad.image} alt={ad.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105" />
            <span className="absolute top-2 left-2 font-mono text-[10px] uppercase tracking-widest bg-background/80 px-2 py-1">Ad</span>
          </div>
          <div className="p-4">
            <p className="text-sm font-medium group-hover:text-primary transition-colors">{ad.title}</p>
          </div>
        </a>
      ))}
    </div>
  );
}
